import { createApi } from '@reduxjs/toolkit/query/react';

import { CheckoutExperienceResponse } from '@/types/CheckoutExperience';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const checkoutExperienceApi = createApi({
  reducerPath: 'checkoutExperienceApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ useStrapiServer: true, basePath: '', cache: 'no-store' }),
  tagTypes: ['CheckoutExperience'],
  endpoints: builder => ({
    getCheckoutExperience: builder.query<CheckoutExperienceResponse, void>({
      query: () => ({
        url: `/pawtree/checkoutExperience`,
      }),
      providesTags: ['CheckoutExperience'],
    }),
  }),
});

export const { useGetCheckoutExperienceQuery } = checkoutExperienceApi;
